import type { Language } from '@/i18n/types';

/** Per-language help center URLs. */
export const HELP_CENTER_URLS: Record<Language, string> = {
  en: 'https://dmsync.datamission.io/hc/en-us',
  fr: 'https://dmsync.datamission.io/hc/fr',
  de: 'https://dmsync.datamission.io/hc/de',
  es: 'https://dmsync.datamission.io/hc/es',
};
